import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

const featuredArticles = articles.filter((a) => a.featured).slice(0, 3);

export default function FeaturedSection() {
  return (
    <section className="w-full px-4 md:px-6 py-16 md:py-20 bg-background-50" data-product-shop="">
      <div className="max-w-[1400px] mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-4xl font-bold text-foreground-900 font-heading mb-4">
            精选推荐
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-[600px] mx-auto">
            经过专业团队的严格测评，为您精选出2025年最值得推荐的观影平台
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {featuredArticles.map((article) => (
            <article
              key={article.id}
              className="group bg-background-50 rounded-xl border border-background-200/70 overflow-hidden hover:border-primary-200/60 transition-all duration-300 cursor-pointer"
            >
              <Link to={`/article/${article.slug}`} className="block">
                <div className="relative aspect-[16/9] overflow-hidden">
                  <img
                    src={article.coverImage}
                    alt={article.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                  />
                  <div className="absolute top-3 left-3">
                    <span className="px-3 py-1 rounded-full bg-accent-500 text-white text-xs font-medium">
                      {article.categoryName}
                    </span>
                  </div>
                  <div className="absolute bottom-3 right-3">
                    <span className="flex items-center gap-1 px-2.5 py-1 rounded-full bg-black/50 backdrop-blur-sm text-white text-xs">
                      <i className="ri-star-fill text-amber-400 text-xs"></i>
                      {article.rating}
                    </span>
                  </div>
                </div>
                <div className="p-5">
                  <h3 className="text-base md:text-lg font-bold text-foreground-900 mb-2 font-heading group-hover:text-primary-600 transition-colors duration-200 line-clamp-2">
                    {article.title}
                  </h3>
                  <p className="text-sm text-foreground-600 line-clamp-2 mb-4 leading-relaxed">
                    {article.excerpt}
                  </p>
                  <div className="flex items-center justify-between text-xs text-foreground-500">
                    <span className="flex items-center gap-1">
                      <i className="ri-user-line"></i>
                      {article.author}
                    </span>
                    <span className="flex items-center gap-1">
                      <i className="ri-time-line"></i>
                      {article.readTime}
                    </span>
                  </div>
                </div>
              </Link>
            </article>
          ))}
        </div>

        <div className="text-center mt-10">
          <Link
            to="/category/paid-platforms"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-full border border-primary-300 text-primary-700 text-sm font-medium hover:bg-primary-50 transition-colors duration-200 whitespace-nowrap cursor-pointer"
          >
            查看全部测评
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}